import { Component } from '@angular/core';
import { Links } from 'src/app/utils/constants';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
	readonly links = Links;

	onOpenLink(url: string) {
		window.open(url, '_blank', 'noopener,noreferrer');
	}
}
